import React, { useEffect, useState } from 'react';
import { RouterProvider } from 'react-router';
import { NoMatch } from '../components/NoMatch';
import { Layout } from '../Layout';
import { createBrowserRouter } from 'react-router-dom';
import Loader from '../components/atoms/loader';
import { useAuthEvents, useRefreshToken } from '@/modules/Auth';
import { REDIRECT_URL, SCOPES } from '@/config';
import {
  addSmRequestInterceptors,
  addSmResponseInterceptors,
  removeSmRequestInterceptors,
  removeSmResponseInterceptors,
} from '@/modules/API/suppliers/sm-rest-api-client';
import NotEnoughPrivileges from '@/pages/NotEnoughPrivileges';

// Correctly use React.lazy for lazy loading
const Suppliers = React.lazy(() => import('@pages/suppliers/SupplierPage'));
const SupplierDetail = React.lazy(() => import('@pages/suppliers/supplierId/SupplierDetailPage'));

const router = createBrowserRouter([
  {
    id: 'root',
    path: '/',
    Component: Layout,
    ErrorBoundary: (err) => {
      throw err;
    },
    children: [
      {
        index: true,
        element: (
          <React.Suspense fallback={<Loader />}>
            <Suppliers />
          </React.Suspense>
        ),
      },
      {
        path: 'suppliers/:supplierId',
        element: (
          <React.Suspense fallback={<Loader />}>
            <SupplierDetail />
          </React.Suspense>
        ),
      },
      {
        path: 'unauthorized',
        element: (
          <React.Suspense fallback={<Loader />}>
            <NotEnoughPrivileges />
          </React.Suspense>
        ),
      },
      {
        path: '*',
        element: <NoMatch />,
      },
    ],
  },
]);

function AppRouter() {
  // Renew token every 59 minutes to ensure the user is still authenticated
  useRefreshToken(SCOPES, REDIRECT_URL);
  const { getAuthToken } = useAuthEvents();

  useEffect(() => {
    const reqInterceptor = addSmRequestInterceptors(async () => await getAuthToken(SCOPES, REDIRECT_URL));
    const resInterceptor = addSmResponseInterceptors(async () => {
      router.navigate('/unauthorized');
    });
    return () => {
      removeSmRequestInterceptors(reqInterceptor);
      removeSmResponseInterceptors(resInterceptor);
    };
  }, [getAuthToken]);

  return <RouterProvider router={router} fallbackElement={<p>Loading...</p>} />;
}

export default AppRouter;
